import { createFileRoute } from '@tanstack/react-router';
import { DataSurfacePage } from '../../features/surface/DataSurfacePage';

// Single entry point — DataSurfacePage reads the URL itself and dispatches
// to the right component (grid, kanban, detail form, board-details).
function SplatRouteWrapper() {
  return <DataSurfacePage />;
}

export const Route = createFileRoute('/_protected/$')({
  component: SplatRouteWrapper,
});
